import { I18n } from 'aws-amplify'

const Strings = () => ({
  organizations: I18n.get('Organizations'),
  countries: I18n.get('Countries'),
  'Afghanistan': I18n.get('Afghanistan'),
  'Albania': I18n.get('Albania'),
  'Algeria': I18n.get('Algeria'),
  'American Samoa': I18n.get('American Samoa'),
  'Andorra': I18n.get('Andorra'),
  'Angola': I18n.get('Angola'),
  'Antigua and Barbuda': I18n.get('Antigua and Barbuda'),
  'Argentina': I18n.get('Argentina'),
  'Armenia': I18n.get('Armenia'),
  'Aruba': I18n.get('Aruba'),
  'Australia': I18n.get('Australia'),
  'Austria': I18n.get('Austria'),
  'Azerbaijan': I18n.get('Azerbaijan'),
  'Bahamas': I18n.get('Bahamas'),
  'Bahrain': I18n.get('Bahrain'),
  'Bangladesh': I18n.get('Bangladesh'),
  'Barbados': I18n.get('Barbados'),
  'Belarus': I18n.get('Belarus'),
  'Belgium': I18n.get('Belgium'),
  'Belize': I18n.get('Belize'),
  'Benin': I18n.get('Benin'),
  'Bermuda': I18n.get('Bermuda'),
  'Bhutan': I18n.get('Bhutan'),
  'Bolivia': I18n.get('Bolivia'),
  'Bosnia and Herzegovina': I18n.get('Bosnia and Herzegovina'),
  'Botswana': I18n.get('Botswana'),
  'Brazil': I18n.get('Brazil'),
  'British Indian Ocean Territory': I18n.get('British Indian Ocean Territory'),
  'Brunei': I18n.get('Brunei'),
  'Bulgaria': I18n.get('Bulgaria'),
  'Burkina Faso': I18n.get('Burkina Faso'),
  'Burundi': I18n.get('Burundi'),
  'Cambodia': I18n.get('Cambodia'),
  'Cameroon': I18n.get('Cameroon'),
  'Canada': I18n.get('Canada'),
  'Cape Verde': I18n.get('Cape Verde'),
  'Cayman Islands': I18n.get('Cayman Islands'),
  'Central African Republic': I18n.get('Central African Republic'),
  'Chad': I18n.get('Chad'),
  'Chile': I18n.get('Chile'),
  'China': I18n.get('China'),
  'Christmas Island': I18n.get('Christmas Island'),
  'Colombia': I18n.get('Colombia'),
  'Comoros': I18n.get('Comoros'),
  'Cook Islands': I18n.get('Cook Islands'),
  'Costa Rica': I18n.get('Costa Rica'),
  'Crimea': I18n.get('Crimea'),
  'Croatia': I18n.get('Croatia'),
  'Cuba': I18n.get('Cuba'),
  'Curaçao': I18n.get('Curaçao'),
  'Cyprus': I18n.get('Cyprus'),
  'Czech Republic': I18n.get('Czech Republic'),
  'Democratic Republic of the Congo': I18n.get('Democratic Republic of the Congo'),
  'Denmark': I18n.get('Denmark'),
  'Djibouti': I18n.get('Djibouti'),
  'Dominica': I18n.get('Dominica'),
  'Dominican Republic': I18n.get('Dominican Republic'),
  'East Timor': I18n.get('East Timor'),
  'Ecuador': I18n.get('Ecuador'),
  'Egypt': I18n.get('Egypt'),
  'El Salvador': I18n.get('El Salvador'),
  'Equatorial Guinea': I18n.get('Equatorial Guinea'),
  'Eritrea': I18n.get('Eritrea'),
  'Estonia': I18n.get('Estonia'),
  'Eswatini': I18n.get('Eswatini'),
  'Ethiopia': I18n.get('Ethiopia'),
  'Falkland Islands': I18n.get('Falkland Islands'),
  'Faroe Islands': I18n.get('Faroe Islands'),
  'Fiji': I18n.get('Fiji'),
  'Finland': I18n.get('Finland'),
  'France': I18n.get('France'),
  'French Guiana': I18n.get('French Guiana'),
  'French Polynesia': I18n.get('French Polynesia'),
  'French Southern Territories': I18n.get('French Southern Territories'),
  'Gabon': I18n.get('Gabon'),
  'Gambia': I18n.get('Gambia'),
  'Georgia': I18n.get('Georgia'),
  'Germany': I18n.get('Germany'),
  'Ghana': I18n.get('Ghana'),
  'Gibraltar': I18n.get('Gibraltar'),
  'Greece': I18n.get('Greece'),
  'Greenland': I18n.get('Greenland'),
  'Grenada': I18n.get('Grenada'),
  'Guam': I18n.get('Guam'),
  'Guatemala': I18n.get('Guatemala'),
  'Guernsey': I18n.get('Guernsey'),
  'Guinea': I18n.get('Guinea'),
  'Guinea-Bissau': I18n.get('Guinea-Bissau'),
  'Guyana': I18n.get('Guyana'),
  'Haiti': I18n.get('Haiti'),
  'Honduras': I18n.get('Honduras'),
  'Hong Kong': I18n.get('Hong Kong'),
  'Hungary': I18n.get('Hungary'),
  'Iceland': I18n.get('Iceland'),
  'India': I18n.get('India'),
  'Indonesia': I18n.get('Indonesia'),
  'Iran': I18n.get('Iran'),
  'Iraq': I18n.get('Iraq'),
  'Ireland': I18n.get('Ireland'),
  'Isle of Man': I18n.get('Isle of Man'),
  'Israel': I18n.get('Israel'),
  'Italy': I18n.get('Italy'),
  'Jamaica': I18n.get('Jamaica'),
  'Japan': I18n.get('Japan'),
  'Jersey': I18n.get('Jersey'),
  'Jordan': I18n.get('Jordan'),
  'Kazakhstan': I18n.get('Kazakhstan'),
  'Kenya': I18n.get('Kenya'),
  'Kiribati': I18n.get('Kiribati'),
  'Kuwait': I18n.get('Kuwait'),
  'Kyrgyzstan': I18n.get('Kyrgyzstan'),
  'Laos': I18n.get('Laos'),
  'Latvia': I18n.get('Latvia'),
  'Lebanon': I18n.get('Lebanon'),
  'Lesotho': I18n.get('Lesotho'),
  'Liberia': I18n.get('Liberia'),
  'Libya': I18n.get('Libya'),
  'Liechtenstein': I18n.get('Liechtenstein'),
  'Lithuania': I18n.get('Lithuania'),
  'Luxembourg': I18n.get('Luxembourg'),
  'Macau': I18n.get('Macau'),
  'Madagascar': I18n.get('Madagascar'),
  'Malawi': I18n.get('Malawi'),
  'Malaysia': I18n.get('Malaysia'),
  'Maldives': I18n.get('Maldives'),
  'Mali': I18n.get('Mali'),
  'Malta': I18n.get('Malta'),
  'Marshall Islands': I18n.get('Marshall Islands'),
  'Martinique': I18n.get('Martinique'),
  'Mauritania': I18n.get('Mauritania'),
  'Mauritius': I18n.get('Mauritius'),
  'Mayotte': I18n.get('Mayotte'),
  'Mexico': I18n.get('Mexico'),
  'Micronesia': I18n.get('Micronesia'),
  'Moldova': I18n.get('Moldova'),
  'Monaco': I18n.get('Monaco'),
  'Mongolia': I18n.get('Mongolia'),
  'Montenegro': I18n.get('Montenegro'),
  'Morocco': I18n.get('Morocco'),
  'Mozambique': I18n.get('Mozambique'),
  'Myanmar': I18n.get('Myanmar'),
  'Namibia': I18n.get('Namibia'),
  'Nauru': I18n.get('Nauru'),
  'Nepal': I18n.get('Nepal'),
  'Netherlands': I18n.get('Netherlands'),
  'New Caledonia': I18n.get('New Caledonia'),
  'New Zealand': I18n.get('New Zealand'),
  'Nicaragua': I18n.get('Nicaragua'),
  'Niger': I18n.get('Niger'),
  'Nigeria': I18n.get('Nigeria'),
  'Niue': I18n.get('Niue'),
  'Norfolk Island': I18n.get('Norfolk Island'),
  'North Korea': I18n.get('North Korea'),
  'North Macedonia': I18n.get('North Macedonia'),
  'Northern Mariana Islands': I18n.get('Northern Mariana Islands'),
  'Norway': I18n.get('Norway'),
  'Oman': I18n.get('Oman'),
  'Pakistan': I18n.get('Pakistan'),
  'Palau': I18n.get('Palau'),
  'Palestine': I18n.get('Palestine'),
  'Panama': I18n.get('Panama'),
  'Papua New Guinea': I18n.get('Papua New Guinea'),
  'Paraguay': I18n.get('Paraguay'),
  'Peru': I18n.get('Peru'),
  'Philippines': I18n.get('Philippines'),
  'Pitcairn Islands': I18n.get('Pitcairn Islands'),
  'Poland': I18n.get('Poland'),
  'Portugal': I18n.get('Portugal'),
  'Puerto Rico': I18n.get('Puerto Rico'),
  'Qatar': I18n.get('Qatar'),
  'Republic of the Congo': I18n.get('Republic of the Congo'),
  'Romania': I18n.get('Romania'),
  'Russia': I18n.get('Russia'),
  'Rwanda': I18n.get('Rwanda'),
  'Réunion': I18n.get('Réunion'),
  'Saint Helena': I18n.get('Saint Helena'),
  'Saint Kitts and Nevis': I18n.get('Saint Kitts and Nevis'),
  'Saint Lucia': I18n.get('Saint Lucia'),
  'Saint Vincent and the Grenadines': I18n.get('Saint Vincent and the Grenadines'),
  'Samoa': I18n.get('Samoa'),
  'San Marino': I18n.get('San Marino'),
  'Saudi Arabia': I18n.get('Saudi Arabia'),
  'Senegal': I18n.get('Senegal'),
  'Serbia': I18n.get('Serbia'),
  'Seychelles': I18n.get('Seychelles'),
  'Sierra Leone': I18n.get('Sierra Leone'),
  'Singapore': I18n.get('Singapore'),
  'Slovakia': I18n.get('Slovakia'),
  'Slovenia': I18n.get('Slovenia'),
  'Solomon Islands': I18n.get('Solomon Islands'),
  'Somalia': I18n.get('Somalia'),
  'South Africa': I18n.get('South Africa'),
  'South Georgia and the South Sandwich Islands': I18n.get('South Georgia and the South Sandwich Islands'),
  'South Korea': I18n.get('South Korea'),
  'South Sudan': I18n.get('South Sudan'),
  'Spain': I18n.get('Spain'),
  'Sri Lanka': I18n.get('Sri Lanka'),
  'Sudan': I18n.get('Sudan'),
  'Suriname': I18n.get('Suriname'),
  'Sweden': I18n.get('Sweden'),
  'Switzerland': I18n.get('Switzerland'),
  'Syria': I18n.get('Syria'),
  'São Tomé and Príncipe': I18n.get('São Tomé and Príncipe'),
  'Taiwan': I18n.get('Taiwan'),
  'Tajikistan': I18n.get('Tajikistan'),
  'Tanzania': I18n.get('Tanzania'),
  'Thailand': I18n.get('Thailand'),
  'Togo': I18n.get('Togo'),
  'Tonga': I18n.get('Tonga'),
  'Trinidad and Tobago': I18n.get('Trinidad and Tobago'),
  'Tunisia': I18n.get('Tunisia'),
  'Turkey': I18n.get('Turkey'),
  'Turkmenistan': I18n.get('Turkmenistan'),
  'Turks and Caicos Islands': I18n.get('Turks and Caicos Islands'),
  'Tuvalu': I18n.get('Tuvalu'),
  'UAE': I18n.get('UAE'),
  'Uganda': I18n.get('Uganda'),
  'Ukraine': I18n.get('Ukraine'),
  'United Kingdom': I18n.get('United Kingdom'),
  'United States': I18n.get('United States'),
  'Uruguay': I18n.get('Uruguay'),
  'Uzbekistan': I18n.get('Uzbekistan'),
  'Vanuatu': I18n.get('Vanuatu'),
  'Vatican City': I18n.get('Vatican City'),
  'Venezuela': I18n.get('Venezuela'),
  'Vietnam': I18n.get('Vietnam'),
  'Wake Island': I18n.get('Wake Island'),
  'Wallis and Futuna': I18n.get('Wallis and Futuna'),
  'Western Sahara': I18n.get('Western Sahara'),
  'Yemen': I18n.get('Yemen'),
  'Zambia': I18n.get('Zambia'),
  'Zimbabwe': I18n.get('Zimbabwe'),
  'Åland Islands': I18n.get('Åland Islands'),
  'Antarctica': I18n.get('Antarctica')
})

export default Strings
